import React, { useEffect } from "react";
import { Field, Form, Formik } from "formik";
import {
  CheckBox,
  GalleryField,
  TextField,
  Select,
  Loading,
} from "components/form";
import { required, validationWrapper, number } from "lib/formValidations";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { generate_uuid } from "lib/helpers";
import axios from "axios";
import * as Icons from "react-feather";
const AddSlide = ({ show, close, submit }) => {
  const core = useCore();

  useEffect(() => {
    core.dispatch(core.getProducts());
  }, []);
  return (
    <Modal show={show} title="افرزودن اسلاید" handleClose={close}>
      <Formik
        initialValues={{ config: [], uuid: generate_uuid(), type: "Image" }}
        onSubmit={(values) => {
          if (!values.product_id) {
            delete values.product_id;
          }
          submit(values);

          close();
        }}
        enableReinitialize
      >
        {({ form, isSubmitting, dirty, values, setFieldValue }) => (
          <Form>
            <div className="box rounded py-3">
              <div className="p-3 justify-aroundintro-x">
                <div className="col-span-12 grid grid-cols-4 gap-2">
                  <Field
                    label="ترتیب نمایش"
                    name="order"
                    component={TextField}
                    type="number"
                    validate={(value) => validationWrapper(value, number)}
                  />
                  <Field label="انتشار " name="active" component={CheckBox} />
                  <Field
                    placeholder="نوع اسلاید"
                    label="نوع اسلاید :"
                    name="type"
                    component={Select}
                    options={[
                      { label: "تصویری", value: "Image" },
                      { label: "ویدیویی", value: "Video" },
                    ]}
                  />
                </div>

                <>
                  <div className="col-span-2 md:grid md:grid-cols-2 md:gap-2">
                    <Field
                      placeholder="عنوان اسلاید"
                      label="عنوان اسلاید :"
                      name="title"
                      component={TextField}
                      validate={(value) => validationWrapper(value, required)}
                    />
                    <Field
                      placeholder="عنوان انگلیسی"
                      label="عنوان انگلیسی :"
                      name="_en*title*text"
                      component={TextField}
                    />
                    <Field
                      placeholder="توضیحات"
                      label="توضیحات :"
                      name="desc"
                      component={TextField}
                    />
                    <Field
                      placeholder="توضیحات انگلیسی"
                      label="توضیحات انگلیسی :"
                      name="_en*desc*text"
                      component={TextField}
                    />
                    <Field
                      placeholder="لینک"
                      label="لینک :"
                      name="link"
                      component={TextField}
                    />
                    <Field
                      placeholder=" لینک انگلیسی"
                      label="لینک  انگلیسی:"
                      name="_en*link*text"
                      component={TextField}
                    />
                  </div>
                  {values.type == "Video" && (
                    <div className="flex justify-beetwen gap-x-1">
                      <div className="w-5/6">
                        <Field
                          placeholder="لینک ویدیو"
                          label="لینک ویدیو:"
                          name="media_source"
                          component={TextField}
                        />
                      </div>
                      <button
                        className="btn btn-primary w-1/6 h-10 mt-6"
                        type="button"
                        onClick={async () => {
                          if (values.media_source) {
                            try {
                              const result = await axios.get(
                                `https://streaming.payamariana.ir/getvideobyid.php?id=${values.media_source}`
                              );
                              setFieldValue("media_source", result.data);
                            } catch (e) {
                              setFieldValue("media_source", "");
                            }
                          }
                        }}
                      >
                        <Icons.RefreshCw />
                      </button>

                      <div className="w-5/6">
                        <Field
                          placeholder=" لینک ویدیو انگلیسی"
                          label="لینک ویدیو انگلیسی:"
                          name="_en*media_source*media"
                          component={TextField}
                        />
                      </div>
                      <button
                        className="btn btn-primary w-1/6 h-10 mt-6"
                        type="button"
                        onClick={async () => {
                          if (values["_en*media_source*media"]) {
                            try {
                              const result = await axios.get(
                                `https://streaming.payamariana.ir/getvideobyid.php?id=${values["_en*media_source*media"]}`
                              );
                              setFieldValue(
                                "_en*media_source*media",
                                result.data
                              );
                            } catch (e) {
                              setFieldValue("_en*media_source*media", "");
                            }
                          }
                        }}
                      >
                        <Icons.RefreshCw />
                      </button>
                    </div>
                  )}
                  <div className="col-span-3 md:grid md:grid-cols-3 md:gap-3">
                    {values.type == "Image" && (
                      <>
                        <Field
                          label="تصویر :"
                          name="media_source"
                          component={GalleryField}
                          dataType="url"
                          validate={(value) =>
                            validationWrapper(value, required)
                          }
                        />
                        <Field
                          label="تصویر انگلیسی :"
                          name="_en*media_source*media"
                          dataType="url"
                          component={GalleryField}
                        />
                      </>
                    )}
                    <Field
                      label="تصویر موبایل :"
                      name="mobile_media_source"
                      component={GalleryField}
                      dataType="url"
                      validate={(value) => validationWrapper(value, required)}
                    />
                    <Field
                      label="تصویر موبایل انگلیسی :"
                      name="_en*mobile_media_source*media"
                      dataType="url"
                      component={GalleryField}
                    />
                    <Field
                      label="تصویر کوچک :"
                      name="thumbnail_media_source"
                      component={GalleryField}
                      dataType="url"
                      validate={(value) => validationWrapper(value, required)}
                    />
                    <Field
                      label="تصویر کوچک انگلیسی :"
                      name="_en*thumbnail_media_source*media"
                      dataType="url"
                      component={GalleryField}
                    />
                  </div>
                </>

                <>
                  {core.productsLoad ? (
                    <Loading />
                  ) : (
                    <Field
                      placeholder="انتخاب محصول"
                      label="انتخاب محصول :"
                      name="product_id"
                      component={Select}
                      options={core.products || []}
                    />
                  )}
                </>

                <button className="btn btn-sm btn-primary" type="submit">
                  ایجاد اسلاید
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default AddSlide;
